// extracted by mini-css-extract-plugin
export default {"contentSubmit":"styles_contentSubmit__VOjh6"};